import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Alert } from 'react-bootstrap';

export default class OverrideDownloadDialog extends Component {
  getInitialState() {
    return { confirm: false };
  }

  state = this.getInitialState();

  onChangeConfirm = () => {
    const { confirm } = this.state;

    this.setState({ confirm: !confirm });
  };

  getDevices = () => {
    const { devices } = this.props;
    const names = devices.map(item => (
      <li key={item.name}>
        <code>{item.name}</code> {item.description}
      </li>
    ));

    return <ol>{names}</ol>;
  };

  render() {
    const { show, onHide, onSuccess, devices } = this.props;
    const { confirm } = this.state;
    const plural = devices.length > 1 ? 's' : '';

    return (
      <Modal
        data-test="modal-overridedownloaddialog"
        dialogClassName="device-dialog"
        backdrop="static"
        show={show}
        onHide={onHide}
      >
        <Modal.Header>
          <Modal.Title data-test="modal-overridedownloaddialog-title">
            Override Download Schedule
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Device{plural} to override:</p>
          {this.getDevices()}
          <Alert bsStyle="warning">
            <label>
              <input
                data-test="modal-overridedownloaddialog-checkbox-confirm"
                type="checkbox"
                checked={confirm}
                onChange={this.onChangeConfirm}
              />{' '}
              I want to override {devices.length} Device{plural}.
            </label>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-cancel"
            onClick={onHide}
            data-test="modal-overridedownloaddialog-button-cancel"
          >
            Cancel
          </Button>
          <Button
            data-test="modal-overridedownloaddialog-button-ok"
            className="btn-add"
            bsStyle="primary"
            onClick={onSuccess}
            disabled={!confirm}
          >
            Override Device{plural} Schedule
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

OverrideDownloadDialog.propTypes = {
  devices: PropTypes.array,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};
